module.exports = __webpack_public_path__ + "media/images/icons/outlined/arrow-down-c362ec6baa262b060358c7fb57ef5f87.svg";